<template>
  <v-app id="award-banner-app">
    <div
      v-if="isShowAwardBanners"
      class="award-banner"
      :class="{
        'award-banner_dark': bannerData.isDarkMode,
        'ma-2': isMobile,
        'mb-6': !isMobile,
      }"
      @click="handleShowMore"
    >
      <div
        class="d-flex align-center"
        :class="isMobile ? 'px-2 pt-1 mb-2' : 'mr-8'"
      >
        <img
          alt="Золотая звезда"
          height="32"
          width="32"
          class="flex-grow-0"
          :class="isMobile ? 'mr-6' : 'mr-8'"
          :src="starIcon"
        >
        <div class="text-body-1">
          {{ bannerData.banner.title }}
        </div>
      </div>
      <div
        class="ml-auto"
        :class="{ 'mr-2': !isMobile }"
      >
        <v-btn
          text
          class="px-2 mr-2"
          :dark="bannerData.isDarkMode"
          @click.stop="handleClose"
        >
          Скрыть
        </v-btn>
        <v-btn
          text
          class="px-2"
          :dark="bannerData.isDarkMode"
          :color="bannerData.isDarkMode ? 'gold' : 'primary'"
          @click.stop="handleShowMore"
        >
          {{ bannerData.banner.button.moreText }}
        </v-btn>
      </div>
    </div>
  </v-app>
</template>

<script>
import Cookies from 'js-cookie'
import { TIME_DEATH_DAY } from 'www/vue_components/common/Award/constants'

export default {
  name: 'AwardBanner',
  props: {
    bannerData: {
      type: [Object, null],
      default: null,
    },
  },
  data: () => ({
    isVisibleBanner: false,
    isMobile: window.MOBILE_VERSION,
  }),
  computed: {
    starIcon() {
      return this.bannerData.isDarkMode
        ? '/static/_v1/pd/icons/stars/star-gold-outlined.svg'
        : '/static/_v1/pd/icons/stars/star-gold-filled.svg'
    },
    isShowAwardBanners() {
      const today = new Date()
      const isStartDate = today > new Date(2025, 8, 29, 0, 0, 0)
      const isEndDate = today > new Date(2025, 10, 31, 0, 0, 0)

      return (
        this.isVisibleBanner
        && isStartDate
        && !window.IS_YDOC
        && window.SITE_SETTINGS.show_award_banners
        && this.bannerData
        && !isEndDate
      )
    },
  },
  mounted() {
    try {
      this.isVisibleBanner = JSON.parse(Cookies.get('award_banner'))
    } catch {
      this.setCookie(true)
      this.isVisibleBanner = true
    }
  },
  methods: {
    handleClose() {
      this.isVisibleBanner = false
      this.setCookie(false)
    },
    setCookie(value) {
      try {
        Cookies.set('award_banner', String(value), {
          expires: TIME_DEATH_DAY,
          path: '/',
        })
      } catch { /* Empty */ }
    },
    handleShowMore() {
      window.open(this.bannerData.banner.button.moreLink, '_blank')
    },
  },
}
</script>

<style lang="scss">
@import '~www/themes/doctors/common/variables';
@import '~www/themes/doctors/common/mixins';

#award-banner-app {
  @include v-app-reset;
}

.award-banner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  border-radius: $border-radius-md;
  border: 1px solid $new-color-gold;
  background-color: $ui-kit-bg-gray-0;
  color: $ui-kit-text;
  padding: 12px 8px;
  cursor: pointer;

  &_dark {
    border-color: $ui-kit-text;
    background-color: $ui-kit-text;
    color: $ui-kit-bg-gray-0;
  }
}
</style>
